import { LobbyUserSignOutModel } from './../models/lobby-user-signout-model';
import { LobbyUserSignInOutDto } from './../models/lobby-user-signinout.dto';
import { UserSigninStatusModel } from '../models/lobby-user-signin-status.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitService } from 'src/app/app-init.service';
import { AppConfigurations } from 'src/app/shared/models/appConfiguration.model';
import { catchError, tap } from 'rxjs/operators';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { Lobby } from '../models/lobby';
import { LobbyServiceWithCategory } from '../models/lobby-service';
import { LobbyServiceCheckList } from '../models/lobby-service-checklist';
import { ForceSignOutData } from '../models/force-signout-data';
import { BranchChangeDto } from '../models/branch-change.dto';
import { StaffMember } from '../models/staff-member';
import { Location } from '../models/location';
import { ImpersonateUserModel } from '../../lobby-staff-status/shared/models/impersonate-user.model';
import { ImpersonateAssistDetailModel } from '../../lobby-staff-status/shared/models/impersonate-assist-detail.model';
import { LWAReason } from '../models/left-without-assistant-reason.model';
import { AssistedMember } from '../models/lobby-entry-detail-edit';
import { Store } from "@ngrx/store";
import { getLoggedInUserInfo } from "src/app/state";
import { State } from "src/app/state/app.state";

declare const window: any;

@Injectable({
  providedIn: 'root'
})
export class LobbyService {

  private baseUrl?: string;
  private apiController?: string;
  private appConfig?: AppConfigurations;
  private orchestratorBaseApi?:string;
  private orchestratorServiceApi?: string;
  private orchestratorLocationApi?: string;
  private locationChangeSource = new BehaviorSubject(false);
  private preferredLanguageId : number = 1;
  getLocationChangeFlag = this.locationChangeSource.asObservable();



  changeLocationChangeFlag(flag: boolean) {
    this.locationChangeSource.next(flag)
  }
  constructor(private http: HttpClient, private appInitService: AppInitService, private store: Store<State>) {
    appInitService.getAppConfiguration$().subscribe({
      next: (config) => this._onRecieveAppConfig(config)
    })
  }

  getPreferredLanguage() {
    this.store.select(getLoggedInUserInfo).subscribe((user) => {
      if (user !== undefined && user !== null && user['preferredLanguage']) {
        this.preferredLanguageId = user['preferredLanguage'];
      }
    }
    );
  }

private get languageParam(): HttpParams {
    return new HttpParams().set('preferredLanguageId', this.preferredLanguageId.toString());
}

  private _onRecieveAppConfig(appConfig: AppConfigurations) {
    this.appConfig = appConfig;
    this.baseUrl = this.appConfig.lobbyApi.baseApiUrl;
    this.apiController = this.appConfig.lobbyApi.lobbyController;
    this.orchestratorBaseApi = this.appConfig.orchestratorApi.baseApiUrl;
    this.orchestratorServiceApi = this.appConfig.orchestratorApi.serviceController;
    this.orchestratorLocationApi = this.appConfig.orchestratorApi.locationsController;

  }
  getLobbyDetails(locationId: number): Observable<Lobby[]> {
    return this.http.get<Lobby[]>(`${this.baseUrl}${this.apiController}?locationId=${locationId}`)
      .pipe(
        catchError(this.handleError)
      );
  }
  getImpersonateUserDetails(locationId: number): Observable<ImpersonateUserModel[]> {   
    return this.http.get<ImpersonateUserModel[]>(`${this.baseUrl}${this.apiController}/${locationId}/impersonateusers`)
      .pipe(
        catchError(this.handleError)
      );
  }


  getAllServices(locationId: number): Observable<LobbyServiceWithCategory[]> {
    this.getPreferredLanguage();
    return this.http.get<LobbyServiceWithCategory[]>(`${this.baseUrl}${this.apiController}/${locationId}/services`,
    {params: this.languageParam}
    )
      .pipe(
        catchError(this.handleError)
      );
  }

  getServices(locationId: number, showInLobby: boolean, showLobbyCategory: any): Observable<LobbyServiceWithCategory[]> {
    this.getPreferredLanguage();
    return this.http.get<LobbyServiceWithCategory[]>(`${this.baseUrl}${this.apiController}/${locationId}/services?showInLobby=${showInLobby}&showCategory=${showLobbyCategory}`,{
      params: this.languageParam
    })
      .pipe(
        catchError(this.handleError)
      );
  }

  getCheckList(serviceId: number): Observable<LobbyServiceCheckList[]> {
    this.getPreferredLanguage();
    return this.http.get<LobbyServiceCheckList[]>(`${this.baseUrl}${this.apiController}/service/${serviceId}/checklist`, {
      params: this.languageParam
    })
      .pipe(
        catchError(this.handleError)
      );
  }

  getCheckListForMultipleServices(serviceIds: number[]): Observable<LobbyServiceCheckList[]> {
    this.getPreferredLanguage();
    return this.http.get<LobbyServiceCheckList[]>(`${this.baseUrl}${this.apiController}/service/checklist?serviceIds=${serviceIds.join(',')}`, {
      params: this.languageParam
    })
      .pipe(
        catchError(this.handleError)
      );
  }

  getAllLocations(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}${this.apiController}/locations`)
      .pipe(
        tap(data => console.log('getAllLocations: ' + JSON.stringify(data))),
        catchError(this.handleError)
      );
  }
  getUserSignInLocations(): Observable<Location[]> {
    return this.http.get<Location[]>(`${this.baseUrl}${this.apiController}/signinuserslocations`)
      .pipe(
        catchError(this.handleError)
      );
  }
 
  getAllUsers(active: boolean): Observable<StaffMember[]> {
    return this.http.get<StaffMember[]>(`${this.baseUrl}${this.apiController}/users?active=${active}`)
      .pipe(
        catchError(this.handleError)
      );
  }

  getSigninUserDetails(userId: number): Observable<UserSigninStatusModel> {
    return this.http.get<UserSigninStatusModel>(`${this.baseUrl}${this.apiController}/signinuserstatus/${userId}`)
      .pipe(
        catchError(this.handleError)
      );
  }

  getLocationsWithActiveLobbyEntries(): Observable<Location[]> {
    return this.http.get<Location[]>(`${this.baseUrl}${this.apiController}/locationsactivelobbyentry`)
      .pipe(
        catchError(this.handleError)
      );
  }

  getLobbyDetailForServiceDeletion(serviceId: number, isDeacttivate:boolean): Observable<any> {
    this.getPreferredLanguage();
    return this.http.get<any>(`${this.orchestratorBaseApi}${this.orchestratorServiceApi}/ServiceDeleteValidation/${serviceId}/${isDeacttivate}`,
      { params: this.languageParam }
    )
      .pipe(
        catchError(this.handleError)
      );
  }

  getLocationDeactivationValidation(): Observable<any> {
    return this.http.get<any>(`${this.orchestratorBaseApi}${this.orchestratorLocationApi}/locationdeactivationvalidation`)
      .pipe(
        catchError(this.handleError)
      );
  }
  signOutUser(signoutmodel: LobbyUserSignOutModel) {
    let params = new HttpParams();
    if (signoutmodel.reason !== '') {
      params = params.append('offlineReason', signoutmodel.reason);
    }
    return this.http.patch(`${this.baseUrl}${this.apiController}/user/offline`
      , { userId: signoutmodel.userId, locationId: signoutmodel.locationId }, { params })
      .pipe(
        catchError(this.handleError)
      );
  }

  signInUser(signinDto: LobbyUserSignInOutDto) {
    return this.http.post(`${this.baseUrl}${this.apiController}/user/signin`, signinDto)
      .pipe(
        catchError(this.handleError)
      );
  }
  
  changeSignInBranch(branchChangeDto: BranchChangeDto) {
    return this.http.put(`${this.baseUrl}${this.apiController}/user/changebranch`, branchChangeDto)
      .pipe(
        catchError(this.handleError)
      );
  }

  getImpersonateAssistDetails(): Observable<ImpersonateAssistDetailModel> {   
    return this.http.get<ImpersonateAssistDetailModel>(`${this.baseUrl}${this.apiController}/impersonateassistdetails`)
      .pipe(
        catchError(this.handleError)
      );
  }
  generateDemoData() {
    return this.http.post(`${this.baseUrl}${this.apiController}/demodata`,null)
      .pipe(
        catchError(this.handleError)
      );
  }
  getLwaReasonsForLobby(): Observable<LWAReason[]> {
    this.getPreferredLanguage();
    const url = `${this.baseUrl}${this.apiController}/lwa`;
    return this.http.get<LWAReason[]>(url, {
      params: this.languageParam
    });
  }
  getAllUsersForProductService(): Observable<AssistedMember[]> {
    return this.http.get<AssistedMember[]>(`${this.baseUrl}${this.apiController}/activeusers`)
      .pipe(
        catchError(this.handleError)
      );
  }
  private handleError(err: any) {
    let errorMessage: string;
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      if (err.status === 400) {
        return throwError(err);
      }
      errorMessage = `Backend returned code ${err.status}: ${err.body.error}`;
    }
    console.error(err);
    return throwError(errorMessage);
  }

  userForceSignOut(forceSignOutData : ForceSignOutData)
  {
    return this.http.patch<any>(`${this.baseUrl}${this.apiController}/user/forcesignout`, forceSignOutData);
  }

  public reAssignService(oldserviceId: number, reassignedServiceId: number): Observable<{}> {
    return this.http.post(`${this.orchestratorBaseApi}${this.orchestratorServiceApi}/RemoveAndReAssignService/${oldserviceId}/${reassignedServiceId}`, null);
  }
}


export const locations = [{ id: 1, name: 'Canton' }, { id: 2, name: 'San jose' }, { id: 3, name: 'Milpitas' }];
export const assistTypes = [{ id: 1, name: 'Instant Assist' }, { id: 2, name: 'Standard Assist' }, { id: 3, name: 'All' }];
